import {
  EXTENDED_WARRANTY_2YEAR_ID,
  EXTENDED_WARRANTY_3YEAR_ID,
} from '@/app/[locale]/store/_consts';
import WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';

export default function getExtendedWarrantyId(
  selection: WarrantySelectionEnum | undefined,
): number | null {
  switch (selection) {
    case WarrantySelectionEnum.TwoYear:
      return EXTENDED_WARRANTY_2YEAR_ID;

    case WarrantySelectionEnum.ThreeYear:
      return EXTENDED_WARRANTY_3YEAR_ID;

    case WarrantySelectionEnum.OneYear:
    default:
      return null;
  }
}
